<!-- StepThree.vue -->
<template>
    <div class="space-y-4">
        <!-- Bank Details  -->
        <div>
            <div class="mx-2 text-xl font-semibold">Bank Details</div>
            <div class="grid grid-cols-1 gap-5 m-2 md:grid-cols-2">
                <!-- Bankers Name -->
                <div>
                    <div class="block text-sm font-semibold text-gray-700">Bankers Name*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.bankersName"
                            type="text"
                            placeholder="Bankers Name"
                            :variant="localErrors.bankers_name ? 'danger' : ''"
                        />
                        <div
                            v-if="localErrors.bankers_name"
                            class="text-red-500"
                        >
                            {{ localErrors.bankers_name }}
                        </div>
                    </div>
                </div>

                <!-- Bankers address -->
                <div>
                    <div class="block text-sm font-semibold text-gray-700">Bankers Address*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.bankersAddress"
                            type="text"
                            placeholder="Bankers address"
                            :variant="localErrors.bankers_address ? 'danger' : ''"
                        />
                        <div
                            v-if="localErrors.bankers_address"
                            class="text-red-500"
                        >
                            {{ localErrors('bankers_address') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            form: { type: Object, required: true },
            errors: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            localErrors() {
                return this.errors || {};
            },
        },
    };
</script>
